// src/app/services/wallet.service.ts
import { Injectable } from '@angular/core';
import { environment } from "@env/environment";
import { TokenService } from './token.service';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class WalletService {

  constructor(private http: HttpClient, private tokenService: TokenService) {}

  getWalletLink(type: string, uuid: string) {
    const token = this.tokenService.getToken();
    const reqHeaders = {
      Authorization: `JWT ${token}`,
    };

    return this.http.get<{ saveUrl: string }>(
      `${environment.baseUrlApi}/wallet/${encodeURIComponent(type)}/${encodeURIComponent(uuid)}/link`, { headers: reqHeaders }
    );
  }

  getApplePkpass(type: string, uuid: string) {
    const token = this.tokenService.getToken();
    return this.http.get(
      `${environment.baseUrlApi}/wallet-apple/${encodeURIComponent(type)}/${encodeURIComponent(uuid)}/download`,
      {
        responseType: 'blob',
        observe: 'response',
        headers: { Authorization: `JWT ${token}` }
      }
    );
  }

}
